<template>
  <v-dialog width="350px" persistent v-model="editDialog">
		<v-btn slot="activator" dark flat class="orange pa-2">
			<v-icon class="white--text text--lighten-1">edit</v-icon>
		</v-btn>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text" @click="editDialog = false">close</v-icon>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs12 class="text-xs-center mb-4">
            <img src="/static/img/victorium_logo.png" />
          </v-flex>
        </v-layout>
        <v-layout row justify-center v-if="error">
          <v-flex xs12 sm6>
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
          </v-flex>
        </v-layout>
        <v-layout row justify-center>
          <v-flex xs10>
            <p class="grey--text">Administrator Login</p>
            <form @submit.prevent="onSignin">
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    name="email"
                    label="Email Address"
                    id="email"
                    v-model="email"
                    type="email"
                    required>
                  </v-text-field>
                  <!-- <v-icon>email</v-icon> -->
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    name="password"
                    label="Password"
                    id="password"
                    v-model="password"
                    type="password"
                    required>
                  </v-text-field>
                  <!-- <v-icon>lock_outline</v-icon> -->
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>                    
                  <v-btn xs4 class="grey lighten-1 white--text" depressed @click.native="editDialog = false">
                    Cancel
                  </v-btn>                     										
                  <v-btn xs4 type="submit" :disabled="loading" :loading="loading" depressed class="cyan white--text">
                    Log In
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span> 
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-flex>
        </v-layout>        
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      editDialog: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    onSignin () {
      // Vuex
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>



// WEBPACK FOOTER //
// SignIn.vue?29ad1002